// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__38qMH","col":"styles_col__uRBPd"};